import BrandsModal from './BrandsModal';

export default BrandsModal;
